import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { locationSlice } from "../locationReducer";
import { LOCATION_SEARCH_PARAM } from "../locationConstants";
import { TLocationName } from "../location.t";
import { getLocationPlatformSelector } from "../locationSelectors";

function useLocationSearchParamWatch() {
    const location = useLocation();
    const dispatch = useDispatch();
    const locationPlatform = useSelector(getLocationPlatformSelector);

    useEffect(() => {
        if (!locationPlatform) { return; }

        const searchParams = new URLSearchParams(location.search);
        const locationSearchParam = searchParams.get(LOCATION_SEARCH_PARAM) as TLocationName | null;
        if (!locationSearchParam) { return;}

        searchParams.delete(LOCATION_SEARCH_PARAM);

        dispatch(locationSlice.actions.openLocationAction({
            method: 'replace',
            name: locationSearchParam,
            searchParams: Object.fromEntries(searchParams.entries()),
            state: location.state,
        }))
    }, [dispatch, location, locationPlatform]);
}

export default useLocationSearchParamWatch;
